import "../css/main.scss"

import Video from './modules/Video';
import ModalsClusters from './modules/ModalsClusters';
import ClusterVideo from './modules/ClusterVideo';
import FullmapItems from './modules/FullmapItems';
import SearchOverlay from './modules/SearchOverlay';
//import Dropdown from './modules/Dropdown';
import Slider from './modules/Slider';
import Totop from './modules/Totop';
import MobileMenu from './modules/MobileMenu';
import Colleges from './modules/Colleges';
import ProfMap from './modules/ProfMap';
import ImageGallery from './modules/ImageGallery';
import Testimony from './modules/Testimony';
import FansyGallery from './modules/FansyGallery';
import ProftestPage from './modules/ProftestPage';

const video = new Video();
const modalsClusters = new ModalsClusters();
const clusterVideo = new ClusterVideo();
const fullmapItems = new FullmapItems();
const searchOverlay = new SearchOverlay();
//const dropdown = new Dropdown();
const slider = new Slider();
const totop = new Totop();
const mobileMenu = new MobileMenu();
const colleges = new Colleges();
const profmap = new ProfMap();
const imageGallery = new ImageGallery();
const testimony = new Testimony();
const fansygallery = new FansyGallery();
const proftest = new ProftestPage();